import React from 'react';
import { Input } from 'antd';
import styles from './InputForm.module.scss';

export default function InputForm() {
    return <Input className={styles.input_form} />;
}
